var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInjective(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M148.497 169.135c2.484-3.122 5.116-6.126 7.748-9.13.118-.149.385-.179.503-.328.237-.297.622-.476.858-.774l.237-.297c1.835-1.696 3.787-3.542 6.038-5.15 7.964-6.046 16.229-10.639 24.944-13.661 27.953-9.814 59.069-3.766 83.47 19.27 34.071 31.937 31.02 83.386 3.822 117.582-34.369 50.978-93.433 122.101-11.654 185.813 14.704 11.456 25.612 20.901 71.929 34.286-30.292 5.58-58.38 3.844-89.644-4.141-22.114-12.482-56.882-39.208-68.711-75.305-17.878-54.738 31.476-136.568 55.328-168.084 32.748-43.617-20.241-90.834-59.253-38.121-20.392 27.471-56.068 105.208-43.67 162.87 7.249 32.699 16.911 56.534 55.221 89.276-7.104-4.192-14.003-8.947-20.695-14.267-89.011-82.914-78.684-211.115-16.471-279.839Z",
    style: {
      fill: "#c1c1d3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M451.503 430.865c-2.484 3.122-5.116 6.126-7.748 9.13-.118.149-.385.179-.503.328-.237.297-.622.476-.858.774l-.237.297c-1.835 1.696-3.787 3.542-6.038 5.15-7.964 6.046-16.229 10.639-24.944 13.661-27.953 9.814-59.069 3.766-83.47-19.27-34.071-31.937-31.02-83.386-3.822-117.582 34.369-50.978 93.433-122.101 11.654-185.813-14.704-11.456-25.612-20.901-71.929-34.286 30.292-5.58 58.38-3.845 89.643 4.141 22.115 12.482 56.883 39.208 68.712 75.305 17.878 54.738-31.476 136.568-55.328 168.084-32.748 43.617 20.241 90.834 59.253 38.121 20.392-27.471 56.068-105.208 43.67-162.87-7.249-32.699-16.911-56.534-55.221-89.276 7.104 4.192 14.003 8.947 20.695 14.267 89.011 82.914 78.684 211.115 16.471 279.839Z",
    style: {
      fill: "#c1c1d3",
      fillOpacity: 1
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 100,
    x2: 500,
    y1: 300,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 100,
    x2: 500,
    y1: 300,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F2FE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjective);
export default __webpack_public_path__ + "static/media/injective.a05dc316f2780a28ef7224cdcfa5d215.svg";
export { ForwardRef as ReactComponent };